export default __webpack_public_path__ + "static/media/img-5.6d2d6313.png";